export default __webpack_public_path__ + "static/media/cont3.b1f34904.jpg";